import { DialogueEffect } from '../types';
import { EffectHandler } from '../EffectBus';

export class MockUIEffectsHandler implements EffectHandler {
  private log: (entry: string) => void;

  constructor(log: (entry: string) => void) {
    this.log = log;
  }

  canHandle(effect: DialogueEffect): boolean {
    return (
      effect.type === 'ADD_MESSAGE' ||
      effect.type === 'SCROLL_TO_BOTTOM' ||
      effect.type === 'SHOW_PROCESSING' ||
      effect.type === 'HIDE_PROCESSING' ||
      effect.type === 'ASK_TASK_DESCRIPTION' ||
      effect.type === 'ASK_VARIANT' ||
      effect.type === 'ASK_AMOUNT' ||
      effect.type === 'ASK_CONFIRMATION'
    );
  }

  async handle(effect: DialogueEffect): Promise<void> {
    switch (effect.type) {
      case 'ADD_MESSAGE':
        this.log(`ADD_MESSAGE: ${effect.message.text || effect.message.textKey || ''}`);
        return;
      case 'SCROLL_TO_BOTTOM':
        this.log('SCROLL_TO_BOTTOM');
        return;
      case 'SHOW_PROCESSING':
        this.log('SHOW_PROCESSING');
        return;
      case 'HIDE_PROCESSING':
        this.log('HIDE_PROCESSING');
        return;
      case 'ASK_TASK_DESCRIPTION':
        this.log(`ASK_TASK_DESCRIPTION: ${effect.prompt}`);
        return;
      case 'ASK_VARIANT':
        this.log(`ASK_VARIANT: options=${effect.options?.length || 0}`);
        return;
      case 'ASK_AMOUNT':
        this.log(`ASK_AMOUNT: ${effect.prompt}`);
        return;
      case 'ASK_CONFIRMATION':
        this.log(`ASK_CONFIRMATION: ${effect.prompt}`);
        return;
      default:
        this.log(`IGNORED_UI_EFFECT: ${(effect as any).type}`);
    }
  }
}


